import React, { createContext, useContext } from 'react';
import { useTopMostLayer } from '../hooks/useTopMostLayer';

type MenuContextType = ReturnType<typeof useTopMostLayer>;

const MenuContext = createContext<MenuContextType | null>(null);

export const useMenu = () => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('useMenu must be used within a MenuProvider');
  }
  return context;
};

export const MenuProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const menuManager = useTopMostLayer();

  return <MenuContext.Provider value={menuManager}>{children}</MenuContext.Provider>;
};
